export const STORE_DASHBOARD_DETAILS = 'STORE_DASHBOARD_DETAILS';

export const GET_DASHBOARD_DETAILS = 'GET_DASHBOARD_DETAILS';

export const GET_LOGGED_INFO = 'GET_LOGGED_INFO';

export const STORE_LOGGED_INFO = 'STORE_LOGGED_INFO';
